import React, { useEffect, useState } from 'react';
import API_BASE_URL from '../config';
import '../App.css';


export default function CertifiedMid() {
  const [orgs, setOrgs] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(25);

  useEffect(() => {
    document.title = 'Large | Outstanding Workplaces!';
    fetchOrgs();
    // eslint-disable-next-line
  }, [page, search, limit]);

  const fetchOrgs = async () => {
   const res = await fetch(
    `${API_BASE_URL}/api/certified-organizations/large?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`
    );
    const data = await res.json();
    setOrgs(data.organizations || []);
    setTotal(data.total || 0);
  };

  return (
    <div className="micro-bg">
      {/* Hero Section */}
      <section className="micro-hero-section">
        <div className="micro-hero-row">
          <div className="micro-hero-left">
            <img
              src="/Badge_TM.png"
              alt="Outstanding Workplaces Certified 2025"
              className="certified-badge"
            />
            <h1 className="micro-hero-title">
              Meet Our Certified Top Outstanding Workplaces!
            </h1>
            <p className="micro-hero-desc">
              We're proud to announce the top workplaces in the country that have been certified by Outstanding Workplaces through a thorough assessment of their work culture. These organizations have demonstrated a commitment to creating a positive and productive work environment that benefits their employees and drives business success.
            </p>
          </div>
          <div className="micro-hero-right">
            <img
              src="/Certified_1.jpg"
              alt="Certified Person"
              className="micro-hero-img"
            />
          </div>
        </div>
      </section>

      <section className="micro-blue-section">
        <div className="micro-blue-container">
          <h2 className="micro-blue-title">
            Check out our list of Certified top workplaces and get inspired!
          </h2>
        </div>
      </section>

      <section className="micro-cards-section">
        <div className="micro-cards-row">
          <OrgCard
            title="Micro Organizations"
            subtitle="(10 - 99 Employees)"
            link="/certified/micro"
          />
          <OrgCard
            title="Mid-Scale Organizations"
            subtitle="(100 - 499 Employees)"
            link="/certified/mid"
          />
          <OrgCard
            title="Large Organizations"
            subtitle="(500 - 2999 Employees)"
            active
            link="/certified/large"
          />
          <OrgCard
            title="Enterprise Organizations"
            subtitle="(3000+ Employees)"
            link="/certified/enterprise"
          />
        </div>
      </section>

      <section className="micro-section-title">
        <div className="micro-section-title-container">
          <h2 className="micro-section-title-text">
            Large Organizations
          </h2>
        </div>
      </section>

      <section className="micro-table-section">
        <div className="micro-table-container">
          <div className="micro-table-header">
            <div className="micro-table-entities">
              Show&nbsp;
              <select
                value={limit}
                onChange={e => { setLimit(Number(e.target.value)); setPage(1); }}
                className="micro-table-select"
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              &nbsp;entries
            </div>
            <div className="micro-table-searchbox">
              Search:&nbsp;
              <input
                type="text"
                placeholder="Search organizations..."
                value={search}
                onChange={e => { setSearch(e.target.value); setPage(1); }}
                className="micro-table-search"
              />
            </div>
          </div>
          <div className="micro-table-wrapper">
            <table className="micro-table">
              <thead>
                <tr>
                  <th className="micro-th">Organization Name</th>
                  <th className="micro-th">Industry</th>
                  <th className="micro-th">No. of Employees</th>
                  <th className="micro-th">Certification Period</th>
                  <th className="micro-th">Company Profile</th>
                  
                </tr>
              </thead>
              <tbody>
                {orgs.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="micro-td-center">No organizations found.</td>
                  </tr>
                ) : orgs.map((org, idx) => (
                  <tr key={idx}>
                    <td className="micro-td">{org.organization_name}</td>
                    <td className="micro-td">{org.industry}</td>
                    <td className="micro-td">{org.number_of_employees}</td>
                    <td className="micro-td">{org.certification_period}</td>
                    <td className="micro-td">
                      {org.profile_url ? (
                        <a
                          href={org.profile_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="micro-profile-btn"
                        >
                          View
                        </a>
                      ) : "-"}
                      </td>
                      <td className="micro-td micro-td-center">
                      {org.certification_type
                        ? org.certification_type.replace(' Outstanding Workplaces', '')
                        : '-'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="micro-table-footer">
            <div className="micro-table-info">
              {total > 0
                ? `Showing ${((page - 1) * limit) + 1} to ${Math.min(page * limit, total)} of ${total} entries`
                : 'Showing 0 to 0 of 0 entries'}
            </div>
            <div className="micro-pagination">
              <button
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
                className="micro-page-btn"
              >
                Previous
              </button>
              {Array.from({ length: Math.min(5, Math.ceil(total / limit)) }, (_, i) => {
                const pageNum = i + 1;
                return (
                  <button
                    key={pageNum}
                    onClick={() => setPage(pageNum)}
                    className={`micro-page-btn${page === pageNum ? " active" : ""}`}
                  >
                    {pageNum}
                  </button>
                );
              })}
              {Math.ceil(total / limit) > 5 && (
                <>
                  <span style={{
                    padding: "0 8px",
                    background: "#f5f5f5",
                    borderRadius: "4px",
                    color: "#222"
                  }}>...</span>
                  <button
                    onClick={() => setPage(Math.ceil(total / limit))}
                    className={`micro-page-btn${page === Math.ceil(total / limit) ? " active" : ""}`}
                  >
                    {Math.ceil(total / limit)}
                  </button>
                </>
              )}
              <button
                disabled={page === Math.ceil(total / limit) || total === 0}
                onClick={() => setPage(page + 1)}
                className="micro-page-btn"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function OrgCard({ title, subtitle, link, active }) {
  return (
    <a
      href={link}
      className={`micro-card${active ? " active" : ""}`}
    >
      <div className="micro-card-title">{title}</div>
      <div className="micro-card-subtitle">{subtitle}</div>
      <button
        className="card-view-btn"
        tabIndex={-1}
        type="button"
      >
        View
      </button>
    </a>
  );
}